import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { SelectFieldMultiList } from 'shared/ui/Select/SelectMultiListField/SelectMultiListField'
import { MultiSelectDropdownContent } from 'entities/Phone/ui/AssignNumberCommon/ui/NewInboxContent/MultiSelectDropdownContent'
import { NewInboxSelectOwner } from 'entities/Phone/ui/AssignNumberCommon/ui/NewInboxContent/NewInboxSelectOwner'
import { NewInboxName } from 'entities/Phone/ui/AssignNumberCommon/ui/NewInboxContent/NewInboxName'
import { ChipWithAvatar } from '../ChipWithAvatar/ChipWithAvatar'
import { NextButton } from '../NextButton/NextButton'
import styles from './styles.module.scss'
import { type NewInboxStore } from './store/newInboxStore'

type INewInboxContentProps = {
  newInboxStore: NewInboxStore
  nextButtonName?: string
  nextClick?: () => void
  loadingButton?: boolean
  hideSubmit?: boolean
  disabledButton?: boolean
}

export const NewInboxContent = observer(
  ({
    newInboxStore,
    nextButtonName,
    nextClick,
    loadingButton,
    hideSubmit = false,
    disabledButton,
  }: INewInboxContentProps) => {
    const {
      selectedMembers,
      membersWithoutObserver,
      setSelectedMembers,
      selectedMembersIds,
      deleteSelectedMembers,
      membersWithoutActiveInboxOwner,
    } = newInboxStore

    const selectedMembersItems = useMemo(() => {
      return selectedMembers.map((item) => ({
        id: item.id,
        label: item.label,
        value: item.value,
        data: {
          isAway: undefined,
          avatarInfo: item.avatarProps?.info,
        },
      }))
    }, [selectedMembers])

    return (
      <>
        <div className={styles.wrap}>
          <NewInboxName
            newInboxStore={newInboxStore}
            labelProps={{
              label: {
                text: 'Inbox name',
              },
            }}
          />

          <>
            {membersWithoutObserver.length > 1 && (
              <NewInboxSelectOwner
                newInboxStore={newInboxStore}
                labelText='Inbox owner'
                btnProps={{
                  size: 'large',
                }}
                excludeMemberIds={selectedMembersIds}
              />
            )}

            {membersWithoutActiveInboxOwner.length > 0 && (
              <SelectFieldMultiList
                withInitialSearch
                ChipComponent={ChipWithAvatar}
                labelText='Inbox members'
                labelProps={{
                  label: {
                    text: 'Inbox members',
                    secondaryText: '(optional)',
                  },
                }}
                dropdownProps={{
                  textFieldProps: {
                    className: styles.selectMembersPadding,
                  },
                  PopperProps: {
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                          // @ts-ignore
                          offset: ({ reference }) => {
                            return [0, -reference.height - 8]
                          },
                        },
                      },
                    ],
                  },
                }}
                items={membersWithoutActiveInboxOwner}
                selectedItems={selectedMembersItems}
                onDelete={deleteSelectedMembers}
                onSelect={setSelectedMembers}
                fullWidth
                customComponent={() => (
                  <MultiSelectDropdownContent
                    ChipComponent={ChipWithAvatar}
                    items={membersWithoutActiveInboxOwner}
                    selectedItems={selectedMembersItems}
                    onSelect={setSelectedMembers}
                    onDelete={deleteSelectedMembers}
                  />
                )}
              />
            )}
          </>
        </div>

        {!hideSubmit && (
          <NextButton
            text={nextButtonName}
            disabled={disabledButton}
            loading={loadingButton}
            onClick={() => nextClick?.()}
          />
        )}
      </>
    )
  }
)
